export default __webpack_public_path__ + "static/safeguard-your-assets-11efcaf870b473d91f87e54e0752ffed.jpg";